<template>
  <v-dialog
    v-model="show"
    width="328px">
    <div class="dialog-container">
      <h2 v-if="title">{{ title }}</h2>
      <p>
        {{ message }}
      </p>
      <div class="dialog-footer">
        <!-- <div> -->
        <v-button
          :type="btnType"
          @click="onConfirm">{{ confirmBtn }}
        </v-button>
        <!-- </div> -->
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'ConfirmBox',
  data() {
    return {
      show: false,
      title: '',
      message: '',
      cancelBtn: 'Cancel',
      btnType: 'primary',
      confirmBtn: 'OK',
      promiseStatus: null,
    }
  },
  methods: {
    confirm() {
      return new Promise((resolve, reject) => {
        this.promiseStatus = {
          resolve,
          reject
        }
      })
    },
    // onCancel() {
    //   this.show = false
    // },
    onConfirm() {
      this.show = false
      this.promiseStatus.resolve()
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  //padding: 30px 20px 20px;
  color: #616266;
  border-radius: 5px;

  h2 {
    font-size: 16px;
    line-height: 30px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding:5px 15px;
  }

  p {
    font-size: 16px;
    line-height: 18px;
    padding: 15px;
  }

  .dialog-footer {
    //margin-top: 15px;
    text-align: right;
    padding: 15px;
    .el-button {
      width: 100%;
      //padding: 8px 15px;
    }
  }
}
</style>